import { render, staticRenderFns } from "./PanelWidgets.vue?vue&type=template&id=0d72bd52&scoped=true"
import script from "./PanelWidgets.vue?vue&type=script&lang=ts"
export * from "./PanelWidgets.vue?vue&type=script&lang=ts"
import style0 from "./PanelWidgets.vue?vue&type=style&index=0&id=0d72bd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72bd52",
  null
  
)

export default component.exports